import React from 'react';
import SectorDonut from '../charts/SectorDonut';
import StyleDonut from '../charts/StyleDonut';
import './PortfolioDashboard.css';

export default function PortfolioDashboard({ scores }) {
  if (!scores?.length) return null;

  return (
    <div className="portfolio-dashboard">
      <h3 className="dashboard-title">Portfolio Dashboard</h3>
      <div className="dashboard-charts">
        <SectorDonut scores={scores} />
        <StyleDonut scores={scores} />
      </div>
    </div>
  );
}
